import axios from "../axios";


/*
|--------------------------------------------------------------------------
| GET PUBLIC OFFER
|--------------------------------------------------------------------------
|
| GET /api/public-offers/:token
|
| No authentication required.
|
*/

export const getPublicOffer = async (
  token
) => {
  const response = await axios.get(
    `/public-offers/${token}`
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| ACCEPT PUBLIC OFFER
|--------------------------------------------------------------------------
|
| POST /api/public-offers/:token/accept
|
| No authentication required.
|
*/

export const acceptPublicOffer = async (
  token
) => {
  const response = await axios.post(
    `/public-offers/${token}/accept`
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| CREATE PUBLIC OFFER LINK
|--------------------------------------------------------------------------
|
| Protected.
|
| Used by admin / sales / agent.
|
| POST /api/public-offers/:offerId/link
|
*/

export const createPublicOfferLink =
  async (offerId) => {
    const response = await axios.post(
      `/public-offers/${offerId}/link`
    );

    return response.data;
  };


/*
|--------------------------------------------------------------------------
| REVOKE PUBLIC OFFER LINK
|--------------------------------------------------------------------------
|
| Protected.
|
| POST /api/public-offers/:offerId/revoke
|
*/

export const revokePublicOfferLink =
  async (offerId) => {
    const response = await axios.post(
      `/public-offers/${offerId}/revoke`
    );

    return response.data;
  };


/*
|--------------------------------------------------------------------------
| DEFAULT API OBJECT
|--------------------------------------------------------------------------
*/

const publicOfferApi = {
  getPublicOffer,
  acceptPublicOffer,
  createPublicOfferLink,
  revokePublicOfferLink,
};


export default publicOfferApi;
